import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
    TCITenantSelectorType,
    USER_ROLES,
    ITCISupplement
} from "@tci/common";
import { BaseAppDetailMenuComponentOutput } from "../../../ng-app-details/ng-app-details-menu";
import { NgToastrService } from "../../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { AbstractTCITenantComponent } from "../../../ng-tenant/tci-tenant-component";
import { ITCICEnvToolsComponentOutput } from "../../../ng-tenant/tci-tenant-components";
import { BaseSupplementListService } from "../base-supplement-list.service";
import { NgEnvToolsComponentInput } from "../../tool-loader/ng-env-tools-loader.component";
import { BehaviorSubject, Subscription } from "rxjs";
import { NgPaginatorComponent } from "../../../ng-shared/ng-components/ng-paginator/ng-paginator.component";
import * as lodash from "lodash";
import { NgWaitService } from "../../../ng-shared/ng-components/ng-wait/ng-wait.service";
import { NgUserService } from "../../../ng-shared/ng-services/ng-user.service";
import { Dialog } from "primeng/primeng";



@Component({
    selector: TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS_EDIT.toString(),
    templateUrl: "./base-supplement-edit.component.html"
})
export class BaseEnvToolsSupplementEditComponent extends AbstractTCITenantComponent<any, any, any>
    implements OnInit, OnDestroy {

    constructor() {
        super();
        // TODO : Implement supplements edit component here.
    }


    ngOnInit(): void {
    }

    ngOnDestroy() {
    }
}
